var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useMemo, useRef } from 'react';
import { ExtendedCustomEventData } from './CustomEventData';
export const GLOBAL_SCOPED_VPDS_EVENT_PROPAGATION_VARIABLE = 'GLOBAL_SCOPED_VPDS_EVENT_PROPAGATION_VARIABLE';
export var Events;
(function (Events) {
    Events[Events["UPDATE"] = 0] = "UPDATE";
})(Events || (Events = {}));
export const CustomEventPropagationContext = React.createContext(undefined);
export const getContext = (enableGlobalSharing, setValue = true) => {
    if (enableGlobalSharing) {
        if (!globalThis[GLOBAL_SCOPED_VPDS_EVENT_PROPAGATION_VARIABLE] && setValue) {
            globalThis[GLOBAL_SCOPED_VPDS_EVENT_PROPAGATION_VARIABLE] = CustomEventPropagationContext;
        }
        return globalThis[GLOBAL_SCOPED_VPDS_EVENT_PROPAGATION_VARIABLE] || CustomEventPropagationContext;
    }
    return CustomEventPropagationContext;
};
export const useCustomEventPropagation = ({ enableGlobalSharing = true } = {}) => {
    const value = useContext(getContext(enableGlobalSharing, false));
    if (value === undefined) {
        throw new Error('Use of useCustomEventPropagation() must be wrapped inside a <CustomEventPropagationProvider />');
    }
    return value;
};
/**
 *
 * @param props
 *
 * @returns
 */
export const CustomEventPropagationProvider = (props) => {
    const { children, enableGlobalSharing = true } = props, rest = __rest(props, ["children", "enableGlobalSharing"]);
    const context = getContext(enableGlobalSharing);
    const parentTracking = useContext(context);
    /** We want the output (fireEvent) to be completely stable, but the context at the time it's called should reflect the latest prop values.
     * This way the props used in the callback chains are always up to date, without thrashing the versions of the
     */
    const propsRef = useRef(Object.assign({ parentTracking }, rest));
    propsRef.current = Object.assign({ parentTracking }, rest);
    const contextValue = useMemo(() => ({
        fireEvent: (data) => {
            const { decorator, callback, name, parentTracking } = propsRef.current;
            const newPathData = [name, ...(data.pathData ? data.pathData : [data.name])];
            const newData = Object.assign(Object.assign({}, data), { pathData: newPathData, extraData: decorator
                    ? typeof decorator === 'function'
                        ? decorator(data.extraData)
                        : Object.assign(Object.assign({}, data.extraData), decorator)
                    : data.extraData });
            callback && callback(new ExtendedCustomEventData(newData));
            parentTracking === null || parentTracking === void 0 ? void 0 : parentTracking.fireEvent(newData);
        },
    }), []);
    return _jsx(context.Provider, Object.assign({ value: contextValue }, { children: children }));
};
//# sourceMappingURL=CustomEventPropagationProvider.js.map